import React, {useState} from "react";
import { LocalAudioTrack } from "twilio-video";
/* import Room from "./Room"; */
import { SELECTED_AUDIO_INPUT_KEY } from "context/session/VideoProvider/constants";
import { useDevices, useVideoContext } from "hooks/session";
/* import { AudioButton } from "../Buttons"; */
import { Box, Button, Center, Flex, HStack, Menu, MenuButton, MenuItem, MenuList, Spacer, Text } from "@chakra-ui/react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

interface Props {
  deviceCategory: string;
  callback: any;
  deviceList: MediaDeviceInfo[];
}

const AudioDropdown: React.FC<Props> = ({deviceCategory, callback, deviceList}: Props) => {
  const { localTracks, getLocalAudioTrack } = useVideoContext();
  const [displayName, setDisplayName] = useState<string>();
  const [chevronDirection, setChevronDirection] = useState<any>(BsChevronDown);
  const track = localTracks.find(
    track => track.kind === "audio"
  ) as LocalAudioTrack;

  const selectDisplayName = (deviceName: string) => {
    setDisplayName(deviceName);
    setChevronDirection(BsChevronDown);
  };

  const selectChevronDirection = () => {
    setChevronDirection(BsChevronUp);
  };

  return(
    <>
      {(deviceList.length > 1) && (
        <>
          <Box mt="25px" width="100%">
            <Text fontWeight="400" fontSize="16px">
              {deviceCategory}
            </Text>
            <Menu>
              {({ isOpen }) => (
                <>
                  <MenuButton
                    isActive={isOpen}
                    as={Button}
                    size="xs"
                    bgColor="gray.700"
                    color="white"
                    borderColor="transparent"
                    _hover={{ bg: "gray.700" }}
                    _active={{ bg: "gray.700" }}
                    _focus={{ bg: "gray.700" }}
                    onClick={selectChevronDirection}
                    width="100%"
                  >
                    <Flex dir="row">
                      <Text fontSize="md" isTruncated>
                        {displayName ? displayName : "Select devices here..."}
                      </Text>
                      <Spacer/>
                      <Center>
                        {chevronDirection}
                      </Center>
                    </Flex>
                    </MenuButton>
                    <MenuList
                      bgColor="gray.700"
                      color="gray.100"
                    >
                      {deviceList.map((device, index) => (
                        <MenuItem
                          onClick={() => {selectDisplayName(device.label); callback(device.deviceId);}}
                          _hover={{ bg: "gray.100", color: "gray.700" }}
                          _focus={{ bg: "gray.100", color: "gray.700" }}
                          key={`audio_input_${index}`}
                        >
                          <Text>
                            {device.label}
                          </Text>
                        </MenuItem>
                      ))}
                    </MenuList>
                </>
              )}
            </Menu>
          </Box>
        </>
      )}
    </>
  );
};

export default AudioDropdown;
